<template>
	<v-container
		fluid
	>
		<v-row>
			<v-col>
				<checkout-form
					:complete="complete"
					:price="price"
					:device-name="deviceName"
					:device-id="deviceId"
					:product-version-id="productVersionId"
					@step="event => step = event"
				/>
			</v-col>
			<v-col
				v-if="step < 3"
				style="padding: 12px 12px 12px 12px !important;"
				cols="12"
				md="4"
				class="order-first order-md-last"
			>
				<product-card
					:complete="complete"
					:price="price"
					:device-name="deviceName"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import CheckoutForm from '../organisms/CheckoutForm.vue';
import ProductCard from '../molecules/ProductCard.vue';

export default {
	name: 'CheckoutContainer',
	components: {
		ProductCard,
		CheckoutForm,
	},

	props: {
		complete: {
			type: Boolean,
			default: false,
		},
		deviceName: {
			type: String,
			required: true,
		},
		deviceId: {
			type: Number,
			required: true,
		},
		productVersionId: {
			type: Number,
			required: true,
		},
		price: {
			type: Number,
			required: true
		}
	},

	data () {
		return {
			step: 1,
			signedUp: false,
		};
	},
};
</script>
